import React from 'react';

import LibrarianDashboard from './Dashboard/LibrarianDashboard';

import BookCategoryList from './BookCategories/BookCategoryList';
import BookCategoryForm from './BookCategories/BookCategoryForm';

import BookList from './Books/BookList';
import AddBook from './Books/AddBook';
import EditBook from './Books/EditBook';
import BookDetails from './Books/BookDetails';

import BookCopyList from './BookCopies/BookCopyList';
import AddBookCopy from './BookCopies/AddBookCopy';
import EditBookCopy from './BookCopies/EditBookCopy';

import ReservationList from './Reservations/ReservationList';

import IssueBook from './Issues/IssueBook';
import IssuedBookList from './Issues/IssueManagementIndex';
import ReturnBook from './Issues/ReturnBook';

import FineList from './Fines/FineList';
import FineRules from './Fines/FineRules';
import CreateFine from './Fines/CreateFine';

import PaymentList from './Payments/PaymentList';
import DepositLedger from './Payments/DepositLedger';
import MembershipPaymentCallback from './Payments/MembershipPaymentCallback';

import MemberList from './Members/MemberList';
import RegisterMember from './Members/RegisterMember';
import StudentList from './Students/StudentList';

import AnnouncementList from './Announcements/AnnouncementList';

import RefundList from './Refunds/RefundList';
import RenewalList from './Renewals/RenewalList';
import NotificationList from './Notifications/NotificationList';

import BarcodePrint from './Print/BarcodePrint';
import SpineLabel from './Print/SpineLabel';

import LibraryCardList from './LibraryCards/LibraryCardList';

import ReportDashboard from './Reports/ReportDashboard';
import ReportsHub from './Reports/ReportsHub';
import ReportRouteWrapper from './Reports/ReportRouteWrapper';

import StudentImport from './Imports/StudentImport';
import BookBulkImport from './Imports/BookBulkImport';

import ReceiptPrint from './Receipts/ReceiptPrint';

export const librarianRoutes = [
  {
    path: '/librarian/dashboard',
    element: <LibrarianDashboard />
  },

  {
    path: '/librarian/book-categories',
    element: <BookCategoryList />
  },
  {
    path: '/librarian/book-categories/add',
    element: <BookCategoryForm />
  },
  {
    path: '/librarian/book-categories/:id/edit',
    element: <BookCategoryForm />
  },

  {
    path: '/librarian/books',
    element: <BookList />
  },
  {
    path: '/librarian/books/add',
    element: <AddBook />
  },
  {
    path: '/librarian/books/:id',
    element: <BookDetails />
  },
  {
    path: '/librarian/books/:id/edit',
    element: <EditBook />
  },

  {
    path: '/librarian/book-copies',
    element: <BookCopyList />
  },
  {
    path: '/librarian/book-copies/add',
    element: <AddBookCopy />
  },
  {
    path: '/librarian/book-copies/:id/edit',
    element: <EditBookCopy />
  },

  {
    path: '/librarian/reservations',
    element: <ReservationList />
  },

  {
    path: '/librarian/issues/create',
    element: <IssueBook />
  },
  {
    path: '/librarian/issues',
    element: <IssuedBookList />
  },
  {
    path: '/librarian/issues/:id/return',
    element: <ReturnBook />
  },

  {
    path: '/librarian/renewals',
    element: <RenewalList />
  },

  {
    path: '/librarian/fine-rules',
    element: <FineRules />
  },
  {
    path: '/librarian/fines',
    element: <FineList />
  },
  {
    path: '/librarian/fines/create',
    element: <CreateFine />
  },

  {
    path: '/librarian/payments',
    element: <PaymentList />
  },
  {
    path: '/librarian/payments/callback',
    element: <MembershipPaymentCallback />
  },
  {
    path: '/librarian/refunds',
    element: <RefundList />
  },
  {
    path: '/librarian/deposit-ledger',
    element: <DepositLedger />
  },

  {
    path: '/librarian/members',
    element: <MemberList />
  },
  {
    path: '/librarian/members/register',
    element: <RegisterMember />
  },
  {
    path: '/librarian/students',
    element: <StudentList />
  },
  {
    path: '/librarian/student-import',
    element: <StudentImport />
  },

  {
    path: '/librarian/book-import',
    element: <BookBulkImport />
  },

  {
    path: '/librarian/announcements',
    element: <AnnouncementList />
  },
  {
    path: '/librarian/notifications',
    element: <NotificationList />
  },

  {
    path: '/librarian/barcodes',
    element: <BarcodePrint />
  },
  {
    path: '/librarian/spine-labels',
    element: <SpineLabel />
  },
  {
    path: '/librarian/library-cards',
    element: <LibraryCardList />
  },
  {
    path: '/librarian/receipt-print',
    element: <ReceiptPrint />
  },
  {
    path: '/librarian/reports',
    element: <ReportsHub />
  },
  {
    // Preserves the previous KPI/summary content exactly as it was — the
    // "Reports" sidebar entry now opens the hub above instead, so nothing
    // that already worked is removed, just relocated to its own URL.
    path: '/librarian/reports/summary',
    element: <ReportDashboard />
  },
  {
    path: '/librarian/reports/:reportKey',
    element: <ReportRouteWrapper />
  },

  // Old route aliases
  {
    path: '/librarian/add-new-book',
    element: <AddBook />
  },
  {
    path: '/librarian/add-book-type',
    element: <BookCategoryList />
  },
  {
    path: '/librarian/book-list',
    element: <BookList />
  },
  {
    path: '/librarian/issued-book-list',
    element: <IssuedBookList />
  },
  {
    path: '/librarian/transaction-book-list',
    element: <PaymentList />
  },
  {
    path: '/librarian/announcementlist',
    element: <AnnouncementList />
  },
  {
    path: '/librarian/books-barcode',
    element: <BarcodePrint />
  },
  {
    path: '/librarian/spine-label',
    element: <SpineLabel />
  },
  {
    path: '/librarian/library-card',
    element: <LibraryCardList />
  }
];